import {Action, action} from 'easy-peasy';

export type TableChartDownloadCallback = () => void;
export type TableChartDownloadCallbackMap = Record<number, TableChartDownloadCallback>;

export interface TableChartDownloadCallbacksModel {
    callbacks: TableChartDownloadCallbackMap;
    setCallback: Action<TableChartDownloadCallbacksModel, TableChartDownloadCallbackMap>;
    removeCallback: Action<TableChartDownloadCallbacksModel, number>;
}

const TableChartDownloadCallbacksModel: TableChartDownloadCallbacksModel = {
    callbacks: {},
    setCallback: action((state, callback) => {
        state.callbacks = {
            ...state.callbacks,
            ...callback,
        };
    }),
    removeCallback: action((state, id) => {
        const {[id]: _, ...rest} = state.callbacks;
        state.callbacks = rest;
    }),
};

export default TableChartDownloadCallbacksModel;
